module.exports = __webpack_public_path__ + "static/media/X.5e3b4f88.svg";